import { assertNever } from "../../misc/assertNever";
import { ProviderProductType } from "./providersApi";

export function isPlaneTicket(type: ProviderProductType) {
  switch (type) {
    case ProviderProductType.WATERBORNE_TRANSPORT_VAT_NP:
    case ProviderProductType.WATERBORNE_TRANSPORT_VAT_0:
    case ProviderProductType.HOTEL:
    case ProviderProductType.HOTEL_VAT_NP:
    case ProviderProductType.ATTRACTION:
    case ProviderProductType.BUS_TRANSPORT_VAT_NP:
    case ProviderProductType.BUS_TRANSPORT_VAT_8:
      return false;
    case ProviderProductType.PLANE_TICKET_VAT_0:
    case ProviderProductType.PLANE_TICKET_VAT_NP:
      return true;
    default:
      return assertNever(type);
  }
}
